export const getSiteOrdersRoute = () => '/orders';
export const getSiteOrderEditRoute = (orderId = null) => '/orders/' + (orderId ?? ':order');